import { Ticket, TicketResultType } from 'types/User/firebaseTypes/ticket';

export const formatDeviceTickets = (data: TicketResultType) => {
    if (data) {
        const tickets: Ticket[] = [];
        for (const entry of Object.values(data)) {
            if (!!entry.id) {
                tickets.push(entry);
            }
        }

        return tickets;
    }
    return [];
};
